import React, { useEffect, useState } from 'react';
import { CloseCircle } from 'iconsax-react';
import CircularProgress from '@mui/material/CircularProgress';
// import '../../../../../Components/FlightsDesinitySearcher/Assets/styles.css';
import axios from 'axios';

export const desinitySearcherTypes = {
  origin: { text: 'Origen', errorText: 'Cambia tu origen', placeholder: 'Origen Vuelo' },
  destination: { text: 'Destino', errorText: 'Cambia tu destino', placeholder: 'Destino Vuelo' },
}

const DesinitySearcher = ({
  type,
  change,
}) => {
  const [search, setSearch] = useState('');
  const [origins, setOrigins] = useState([]);
  const [error, setError] = useState(false);

  const filterCity = async (e) => {
    const text = e.target.value
    setSearch(text)
  }

  const searchCity = async () => {
    try {
      if (error) return;
      const url = 'https://travelflight.pdtcomunicaciones.com/api/airports';
      const result = await axios.post(url, { "code": `${search}` });
      if (result.data.length === 0) {
        setError(true)
        setSearch(`Invalido: ${search}`)
        setOrigins([])
      }
      else {
        setError(false)
        setOrigins(result.data)
      }
    } catch (error) {
      console.log("Error in searchCity: ", error)
    }
  }


  function IconToShow() {
    if (error) {
      return <div style={{cursor:"pointer"}} onClick={() => { setSearch('') }}><CloseCircle size="30" color="#FF0000" /></div>
    }
    else {
      if (search.length >= 3) {
        if (origins.length === 0) {
          return <CircularProgress size={25}/>
        }
        else {
          return <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none"><path d="M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10Z" stroke="#2ECC71" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="m7.75 12 2.83 2.83 5.67-5.66" stroke="#2ECC71" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        }
      }
    }
  }

  useEffect(() => {
    if (search.length >= 3) {
      searchCity()
    }
    else if (error) {
      setError(false);
    }
  }, [search]);


  return (
    <div>
      <div className='flight-searchCities_input'>
        <input type="text" placeholder={type.placeholder} onChange={filterCity} required value={search} />
        {IconToShow()}
      </div>
      <div className='flight-searchCities_cities'>
       {origins.map((cityData, key) => {
         return (
           <div key={key} className='cityData_result'>
             <button
               key={cityData?.id}
               style={{
                 border: 'none',
                 width: '100%',
                 height: '50px',
                 position: 'absolute',
                 top: '0',
                 display: 'flex',
                 display: 'block',
                 zIndex: 6,
                 backgroundColor: 'rgba(0, 0, 0, 0)',
                 cursor: 'pointer'
               }}
              onClick={()=>change(cityData)}
             />

             <div className='cityData'>
               <div className='cityData_text'>
                 <div className='cityData_cityCountry'>
                   <p>{cityData?.city} - {cityData?.country}</p>
                 </div>
                 <div className='cityData_abr'>
                   <p>{cityData?.iata}</p>
                 </div>
               </div>
             </div>

           </div>
         )
       })}
       </div>
    </div>
  )
}
export default DesinitySearcher;
